import InfoArea from "@core-components/info-area/InfoArea";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { SimpleGrid, Stack, Text } from "@mantine/core";
import { Fragment } from "react/jsx-runtime";
import ValorantGradientText from "./ValorantGradientText";

const ValorantHowToBuyProduct = () => {
  const { t } = useAppTranslation("pages.valorant.howToBuy");

  const areas = [
    {
      title: t("items.step1.title"),
      description: t("items.step1.description"),
    },
    {
      title: t("items.step2.title"),
      description: t("items.step2.description"),
    },
    {
      title: t("items.step3.title"),
      description: t("items.step3.description"),
    },
  ];

  const getInfoArea = (title: string, description: string) => (
    <InfoArea
      hasBorder
      className="!p-6 h-full max-w-[400px]"
      classNames={{
        description: "!text-base",
      }}
      description={description}
      headLine={
        <SSHeadline
          props={{
            title: { order: 3, className: "font-secret-narrow text-2xl" },
            stack: { align: "left" },
          }}
        >
          <SSWhiteText>{title}</SSWhiteText>
        </SSHeadline>
      }
    />
  );

  return (
    <Stack gap={50}>
      <Stack gap={10} align="center">
        <SSHeadline props={{ title: { fz: 24 } }}>
          <SSWhiteText>{t("titlePrefix")}</SSWhiteText>
          <ValorantGradientText> SECRETSMURFS.GG </ValorantGradientText>
          <SSWhiteText>{t("titleSuffix")}</SSWhiteText>
        </SSHeadline>
        <Text className="text-center font-inter text-lg text-primary-light-text md:w-[80%] xl:w-[55%]">
          {t("description")}
        </Text>
      </Stack>
      <SimpleGrid
        className="px-3"
        cols={{ base: 1, sm: 2, md: 3 }}
        verticalSpacing={"xl"}
      >
        {areas.map((area) => (
          <Fragment key={area.title}>
            {getInfoArea(area.title, area.description)}
          </Fragment>
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default ValorantHowToBuyProduct;
